/* src/app/shared/checklist-modal/checklist-modal.component.scss */
.inner-wrapper {
  padding-top: env(safe-area-inset-top);
}
.checklist-question {
  width: 100%;
}
.dismiss-button ion-icon {
  font-size: 40px;
}
ion-spinner {
  height: 50px;
  transform: scale(1.8);
}
ion-slides,
ion-slide {
  height: 100%;
}
.control-bar {
  position: absolute;
  bottom: 0;
  z-index: 1;
  width: 100%;
}
/*# sourceMappingURL=checklist-modal.component.css.map */
